import { isly } from "isly";
import { Numeric as YearNumeric } from "./Numeric";
export var Year;
(function (Year) {
    var _a;
    Year.Numeric = YearNumeric;
    _a = isly
        .string("value", /^[0-9]{4}$/)
        .rename("isoly.Date.Year")
        .describe("Year in a 4-digit form (YYYY).")
        .bind(), Year.type = _a.type, Year.is = _a.is, Year.flawed = _a.flawed;
    function create(value) {
        return Year.Numeric.is(value) ? value.toString().padStart(4, "0") : undefined;
    }
    Year.create = create;
    function isLeapYear(year) {
        return Year.Numeric.isLeapYear(typeof year == "number" ? year : Year.Numeric.parse(year));
    }
    Year.isLeapYear = isLeapYear;
})(Year || (Year = {}));
//# sourceMappingURL=index.js.map